import { request } from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const getEventlist = async ({
  commit
}) => {
  const eventData = await request(API.EVENT_CARD, 'POST', {})
  if (eventData.success) {
    commit(types.UPDATE_EVENT, {
      cards: eventData.cardsData,
      userName: eventData.userName,
      userId: eventData.userId
    })
    return {
      success: true,
      cards: eventData.cardsData,
      userName: eventData.userName,
      userId: eventData.userId
    }
  } else {
    commit(types.UPDATE_EVENT, {
      cards: [],
    })
    return {
      success: false,
      userId: '',
      msg: eventData.msg,
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/eventList/actions.js